var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 45,
    viewBox: "0 0 47 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6733 2.55431C22.378 0.973333 24.622 0.973332 25.3267 2.55431L29.7555 12.4899C30.3369 13.7941 31.5692 14.6894 32.9892 14.8393L43.8071 15.9811C45.5285 16.1628 46.2219 18.297 44.9361 19.4557L36.8553 26.7381C35.7947 27.6939 35.3239 29.1427 35.6202 30.5394L37.8772 41.1807C38.2364 42.874 36.4209 44.193 34.9215 43.3282L25.4985 37.8933C24.2617 37.1799 22.7383 37.1799 21.5015 37.8933L12.0785 43.3282C10.5791 44.193 8.76364 42.874 9.12279 41.1807L11.3798 30.5394C11.6761 29.1427 11.2053 27.6939 10.1447 26.7381L2.06392 19.4557C0.778089 18.297 1.47153 16.1628 3.1929 15.9811L14.0108 14.8393C15.4308 14.6894 16.6631 13.7941 17.2445 12.4899L21.6733 2.55431Z",
    fill: "white",
    stroke: "#FAC214",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRating);
export default __webpack_public_path__ + "static/media/star-rating.c02bc44270f8b124eba76fe9f1f7ffe3.svg";
export { ForwardRef as ReactComponent };